import React, { useState } from 'react'

import LegalPageFaqEntry from './LegalPageFaqEntry'

import classes from './LegalPageFaq.module.scss'

export default ({ title, anchor, entries }) => {
  const [expandedEntryId, setExpandedEntryId] = useState(null)
  return (
    <div className={classes.section}>
      {anchor && <a id={`${anchor}`} className="named-anchor" href="!#" />}
      <h3 className={classes.title}>{title}</h3>
      {entries.map(entry => (
        <LegalPageFaqEntry
          key={entry.sys.id}
          question={entry.question}
          answer={entry.answer}
          expanded={entry.sys.id === expandedEntryId}
          onToggle={doExpand => setExpandedEntryId(doExpand ? entry.sys.id : null)}
        />
      ))}
    </div>
  )
}
